/** 音量・速さ・字幕・閉じた位置を覚える場所 (localStorage が使えない時は覚えないだけにする) */
export const KEY_VOL = "lesson-player:volume";
export const KEY_RATE = "lesson-player:rate";
export const KEY_CC = "lesson-player:captions";
/** 授業アーカイブで、終わったら次の回へ自動で進むか (既定は進む) */
export const KEY_AUTONEXT = "lecture-player:autonext";
export const keyPos = (slug: string) => `lesson-player:pos:${slug}`;
/** 最後まで見た (終わりの 5 秒に入った・「演習を始める」を押した) 印 */
export const keyDone = (slug: string) => `lesson-player:done:${slug}`;

/** 続きからにする範囲。最初の 3 秒より後で、最後の 5 秒より前 */
export const RESUME_MIN = 3;
export const FINISH_MARGIN = 5;

export function recall<T>(k: string): T | null {
  try {
    return JSON.parse(localStorage.getItem(k) ?? "null") as T | null;
  } catch {
    return null;
  }
}

export function keep(k: string, v: unknown) {
  try {
    if (v === null) localStorage.removeItem(k);
    else localStorage.setItem(k, JSON.stringify(v));
  } catch {
    /* 覚えられない時はそのまま */
  }
}

/**
 * プレーヤーの外 (レッスンページのカード) から、見たところまでを読む口。
 * 鍵の形と「続き」にする範囲はプレーヤーと同じものを使う
 */
export function readLessonVideoProgress(
  slug: string,
  total: number,
): { resumeAt: number | null; watched: boolean } {
  const pos = recall<{ t?: number }>(keyPos(slug));
  const t = typeof pos?.t === "number" && Number.isFinite(pos.t) ? pos.t : null;
  const resumeAt = t !== null && t > RESUME_MIN && t < total - FINISH_MARGIN ? t : null;
  return { resumeAt, watched: recall<boolean>(keyDone(slug)) === true };
}
